import AdminApi from '../services/api';
import swal from 'sweetalert2';

/* init */

const AdminApiService = new AdminApi()

export default{

    props: ['show','companyId'],

    data() {
        return {
            title: '',
            isLoading: false,
            name: '',
            surname: '',
            username: '',
            password: '',
            hasError: ''
        };
    },

    watch: {
        show: function(val, oldVal) {

        },
        name: function(val, oldVal) {
            this.hasError = '';
        },
        surname: function(val, oldVal) {
            this.hasError = '';
        },
        username: function(val, oldVal) {
            this.hasError = '';
        },
        password: function(val, oldVal) {
            this.hasError = '';
        }
    },

    methods: {
        close() {
            this.$topnavbar.$emit('closeAddCompanyStuff')
        },
        successUpdate(){
            this.$topnavbar.$emit('successAddCompanyStuff')
        },

        addCompany: addCompany,
        reset: reset,
    }
}

function addCompany() {
    if(this.name.length === 0 ||
        this.surname.length === 0 ||
        this.username.length === 0 ||
        this.password.length === 0
       ) {
        this.hasError = "Molimo popunite sva polja";
        return;
    }
    let _self = this;
    const newModel = {
        firstName: _self.name,
        lastName: _self.surname,
        username: _self.username,
        password: _self.password
    };
    _self.isLoading = true;
    let companyId = _self.companyId;
    AdminApiService.createCompanyStuff(newModel, companyId)
        .then((response) => {
            _self.reset();
            _self.isLoading = false;
            _self.successUpdate();
        })
        .catch((error) => {
            _self.reset();
            _self.isLoading = false;
            _self.hasError = "Greška prilikom dodavanja."
        })

}

function reset() {
    this.username = '';
    this.password = '';
    this.name = '';
    this.surname = '';
}



// WEBPACK FOOTER //
// ./src/modals/AddCompanyStuffModal.js